module.exports = __webpack_public_path__ + "img/filipbasara_gabee_watch_mock.cadac861.jpg";